import api from './api';

// Tableau de bord — KPI globaux « reste à faire ».
// Un seul appel : le backend ne renvoie que les KPI dont la page est accessible
// au token, déjà filtrés par la règle de cloisonnement concession.
const dashboardApi = {
  getKpis: (params) => api.get('/dashboard/kpis', params ? { params } : undefined),
};

export default dashboardApi;
